import React from 'react';
import { AlertTriangle } from 'lucide-react';
import { Button } from '../ui';
import { UI_TEXT } from '../../constants';

export const ConfirmationModal = ({ isOpen, onClose, onConfirm, userInfo, accountInfo, redeemCode, isOverwrite }) => {
  if (!isOpen) return null;

  const { CONFIRM_DIALOG } = UI_TEXT;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="flex min-h-full items-center justify-center p-4">
        <div className="fixed inset-0 bg-black bg-opacity-50 transition-opacity" onClick={onClose}></div>

        <div className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg">
          <div className="bg-white px-4 pb-4 pt-5 sm:p-6 sm:pb-4">
            <div className="sm:flex sm:items-start">
              <div className={`mx-auto flex h-12 w-12 flex-shrink-0 items-center justify-center rounded-full ${isOverwrite ? 'bg-orange-100' : 'bg-yellow-100'} sm:mx-0 sm:h-10 sm:w-10`}>
                <AlertTriangle className={`h-6 w-6 ${isOverwrite ? 'text-orange-600' : 'text-yellow-600'}`} />
              </div>
              <div className="mt-3 text-center sm:ml-4 sm:mt-0 sm:text-left">
                <h3 className="text-lg font-semibold leading-6 text-gray-900">
                  {isOverwrite ? '确认覆盖充值' : CONFIRM_DIALOG.TITLE}
                </h3>
                <div className="mt-2">
                  <p className="text-sm text-gray-500">
                    {CONFIRM_DIALOG.DESCRIPTION}
                  </p>
                  <div className="mt-4 bg-gray-50 rounded p-3">
                    <dl className="space-y-2">
                      <div className="flex justify-between">
                        <dt className="text-sm font-medium text-gray-600">账号邮箱：</dt>
                        <dd className="text-sm text-gray-900">{userInfo?.email}</dd>
                      </div>
                      <div className="flex justify-between">
                        <dt className="text-sm font-medium text-gray-600">账号类型：</dt>
                        <dd className="text-sm text-gray-900">{accountInfo?.is_free ? '免费账号' : '会员账号'}</dd>
                      </div>
                      {isOverwrite && accountInfo?.expires_at && (
                        <div className="flex justify-between">
                          <dt className="text-sm font-medium text-gray-600">当前到期：</dt>
                          <dd className="text-sm text-orange-600 font-medium">{accountInfo.expires_at}</dd>
                        </div>
                      )}
                      <div className="flex justify-between">
                        <dt className="text-sm font-medium text-gray-600">兑换码：</dt>
                        <dd className="text-sm font-mono text-gray-900">{redeemCode}</dd>
                      </div>
                    </dl>
                  </div>
                  {isOverwrite && (
                    <div className="mt-3 p-3 bg-orange-50 border border-orange-200 rounded-lg">
                      <p className="text-sm text-orange-800 font-medium">
                        该账号已有会员，覆盖充值将以今天开始重新计算一个月。
                      </p>
                    </div>
                  )}
                  <p className="mt-3 text-sm text-red-600 font-medium">
                    {CONFIRM_DIALOG.WARNING}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div className="bg-gray-50 px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
            <Button
              onClick={onConfirm}
              className="sm:ml-3 sm:w-auto w-full"
            >
              {isOverwrite ? '确认覆盖充值' : CONFIRM_DIALOG.CONFIRM_BUTTON}
            </Button>
            <Button
              variant="outline"
              onClick={onClose}
              className="mt-3 sm:mt-0 sm:w-auto w-full"
            >
              {CONFIRM_DIALOG.CANCEL_BUTTON}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};